/* eslint-disable */

export const CommerceRequestedAction = {
  Book: 'book',
  Buyout: 'buyout',
  JoinWaitlist: 'join_waitlist',
  Purchase: 'purchase',
  PayLater: 'pay_later',
  External: 'external'
} as const;
export type CommerceRequestedAction = typeof CommerceRequestedAction[keyof typeof CommerceRequestedAction];
